import docCookies from 'doc-cookies';
import { trackPurchase } from './data-layer-events';

import {
  BASE_URL_EVENTS,
  BASE_URL_ORDER,
  BASE_URL_SANCTUM,
  BASE_URL_ARES,
  BASE_URL_BOOKS,
  SERVICE_ACCOMODATION_ID,
  SERVICE_PARKING_ID,
  VAT,
} from '../misc/consts';
import {
  locale,
  formatedDay,
  formatedMonth,
  formatedYear,
  tcDays,
} from '../alpine-functions';

const DEFAULT_ATTENDEE = {
  email: '',
  name: '',
  services: [],
};
const BASE_URL_PROMO_CODES =
  '/api/collections/promo_codes/entries?filter[title:equals]=';

export default function (cartItem = '', packageType) {
  return {
    order: this.$persist({
      products: [],
      contact: {
        name: '',
        email: '',
        same_delivery_details: true,
      },
      discount: {
        discount: 0,
        absoluteDiscount: false,
        promo_code: '',
      },
      hash: null,
    }),
    loading: cartItem !== '' ? true : false,
    step: 'order',
    submitInProgress: true,
    sumbittedSuccessfully: false,
    sameDeliveryDetails: true,
    deliveryType: null,
    showPromoCode: false,

    get totalProducts() {
      return this.order.products.reduce((amount, product) => {
        if (product.category === 'course') {
          return product.attendees.length + amount;
        }
        return product.quantity + amount;
      }, 0);
    },

    get removeVisible() {
      return this.order.attendees.length > 1;
    },

    get hasInvalidCompanyNumber() {
      return (
        typeof this.order.contact.company_number === 'undefined' ||
        this.order.contact.company_number.length !== 8
      );
    },

    get available() {
      return true;
      /*
      if (this.order.event === undefined || this.order.event === null) {
        return false;
      }
      return this.order.event.capacity !== SOLD_OUT_MARK;
      */
    },

    updateNumberServices(service, value) {
      if (typeof value == 'boolean') {
        value = value ? 1 : 0;
      }
      let servicesIndex = this.attendee.services.findIndex((item) => {
        return JSON.parse(item).id == service.id;
      });

      if (servicesIndex > -1) {
        if (value == 0) {
          this.attendee.services.splice(servicesIndex, 1);
        } else {
          this.attendee.services[servicesIndex] = JSON.stringify(
            this.updateServiceQuantity(service, value)
          );
        }
      } else {
        this.attendee.services.push(
          JSON.stringify(this.updateServiceQuantity(service, value))
        );
      }
    },

    getServiceValue(service) {
      let serviceInfo = this.attendee.services.find((item) => {
        return JSON.parse(item).id == service.id;
      });
      if (serviceInfo) {
        return JSON.parse(serviceInfo).quantity;
      }
      return 0;
    },

    get totalPrice() {
      var coursesPrice = 0;
      let booksPrice = 0;
      this.order.products.forEach((product) => {
        if (product.category === 'course') {
          let servicePrice = product.attendees.reduce(
            (priceForAttendees, attendee) => {
              if (attendee.services.length) {
                return (
                  priceForAttendees +
                  attendee.services.reduce((pricePerAttendee, service) => {
                    let parsedService = JSON.parse(service);
                    return (
                      pricePerAttendee +
                      parseInt(parsedService.price, 10) * parsedService.quantity
                    );
                  }, 0)
                );
              }
              return priceForAttendees;
            },
            0
          );
          coursesPrice +=
            (parseInt(product.price, 10) +
              this.selectedPackage(product).price) *
              product.attendees.length +
            servicePrice;
        } else {
          booksPrice += product.price * product.quantity;
        }
      });
      let coursesPriceDiscounted = coursesPrice + booksPrice;
      if (this.order.discount.discount !== 0) {
        if (this.order.discount.absoluteDiscount) {
          coursesPriceDiscounted =
            coursesPrice - Math.abs(this.order.discount.discount);
        } else {
          coursesPriceDiscounted =
            coursesPrice * (1 - Math.abs(this.order.discount.discount) / 100);
        }
      }
      return {
        noDiscount: coursesPrice + booksPrice,
        discount:
          coursesPriceDiscounted + booksPrice <= 0
            ? 0
            : coursesPriceDiscounted + booksPrice,
      };
    },

    get totalFormatedPrice() {
      return {
        withoutDiscount: this.formatedMoney(this.totalPrice.noDiscount),
        withoutVat: this.formatedMoney(this.totalPrice.discount),
        withVat: this.formatedMoney(this.totalPrice.discount * VAT),
        vat: this.formatedMoney(
          this.totalPrice.discount * VAT - this.totalPrice.discount
        ),
      };
    },

    get hasProductToDelivery() {
      let hasProductToDelivery = this.order.products.filter((product) => {
        return product.category !== 'course';
      }).length;
      return hasProductToDelivery;
    },

    get hasProduct() {
      return this.order.products.length;
    },

    init() {
      this.addToCart();
    },

    countableService() {
      return (
        this.service.id === SERVICE_ACCOMODATION_ID ||
        this.service.id === SERVICE_PARKING_ID
      );
    },

    selectedPackage(product) {
      const packageIndex = product.course.packages.findIndex((item) => {
        return product.selected_package == item.id;
      });
      return {
        price: product.course.packages[packageIndex]
          ? product.course.packages[packageIndex].price
          : 0,
        title: product.course.packages[packageIndex]
          ? product.course.packages[packageIndex].title
          : '',
      };
    },

    addToCart() {
      if (cartItem !== '') {
        if (isNaN(cartItem)) {
          this.getBook(cartItem);
        } else {
          this.getEvent(cartItem);
        }
        history.replaceState({}, null, window.location.href.split('?')[0]);
      }
    },

    removeAsterisks(text) {
      return text.replaceAll('**', '');
    },

    addAttendee(productIndex) {
      this.order.products[productIndex].attendees.push(
        JSON.parse(JSON.stringify(DEFAULT_ATTENDEE))
      );
    },

    removeAttendee(productIndex, attendeeIndex) {
      this.order.products[productIndex].attendees.splice(attendeeIndex, 1);
    },

    formatedMoney(czk) {
      return `${parseInt(czk).toLocaleString(locale())} Kč`;
    },

    getEvetTypeText(eventType, city = '') {
      if (eventType === 'virtual') {
        return 'Online (virtuální třída)';
      }
      if (eventType === 'in_person') {
        return `Prezenčně (${city})`;
      }
      return 'Vybert formu';
    },

    getServiceName(service) {
      if (service.id === SERVICE_ACCOMODATION_ID) {
        return `${service.name} - počet nocí: ${service.quantity}`;
      }
      if (service.id === SERVICE_PARKING_ID) {
        return `${service.name} - počet dnů: ${service.quantity}`;
      }

      return service.name;
    },

    updateServiceQuantity(service, quantity = 1) {
      service.quantity = quantity;
      return service;
    },

    date(event) {
      return `${formatedDay(event.start_date)} ${formatedMonth(
        event.start_date
      )} ${formatedYear(event.start_date)} (${tcDays(
        event.course.duration,
        event.course.custom_duration
      )})`;
    },

    validateEmail(email) {
      const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },

    isValid() {
      return this.$refs['order-form'].reportValidity();
    },

    getBook(id) {
      fetch(`${BASE_URL_BOOKS}${id}`)
        .then((response) => response.json())
        .then((response) => {
          this.order.products.push({ ...response.data, ...{ quantity: 1 } });
        })
        .finally(() => {
          this.$dispatch('cart:updated', this.totalProducts);
          this.loading = false;
        });
    },

    getEvent(event) {
      fetch(`${BASE_URL_EVENTS}${event}`)
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
        })
        .then((response) => {
          this.order.products.push({
            ...response,
            ...{
              selected_event_type:
                response.event_type == 'virtual' ? 'virtual' : 'in_person',
            },
            ...{
              selected_package: this.matchSelectedPackage(response),
            },
            ...{ attendees: [JSON.parse(JSON.stringify(DEFAULT_ATTENDEE))] },
          });
        })
        .finally(() => {
          this.$dispatch('cart:updated', this.totalProducts);
          this.loading = false;
        });
    },

    async getXsfrToken() {
      const response = await fetch(BASE_URL_SANCTUM);
      if (!response.ok) {
        throw new Error(`Error! status: ${response.status}`);
      }
    },

    async applyPromoCode() {
      fetch(`${BASE_URL_PROMO_CODES}${this.order.discount.promo_code}`)
        .then((response) => response.json())
        .then((response) => {
          if (response.data.length) {
            const responseData = response.data[0];
            this.order.discount.absoluteDiscount = responseData.use_absolute;
            responseData.use_absolute
              ? (this.order.discount.discount = parseFloat(
                responseData.absolute_discount
                ))
              : (this.order.discount.discount = parseFloat(
                  responseData.percent_discount
                ));
          } else {
            this.order.discount.promo_code = '';
          }
        });
      this.promoCodeEntered = true;
    },

    async getAresData() {
      if (
        this.order.contact.company_number.length === 8 &&
        !isNaN(this.order.contact.company_number)
      ) {
        const response = await fetch(
          `${BASE_URL_ARES}${this.order.contact.company_number}`
        );
        if (!response.ok) {
          throw new Error(`Error! status: ${response.status}`);
        }
        const data = await response.json();
        this.order.contact = { ...this.order.contact, ...data };
      }
    },

    toBillingInfo() {
      this.order.contact.name =
        this.order.products[0].category === 'course'
          ? this.order.products[0].attendees[0].name
          : '';
      this.order.contact.email =
        this.order.products[0].category === 'course'
          ? this.order.products[0].attendees[0].email
          : '';
      if (this.$refs['order-form'].reportValidity()) {
        this.step = 'billingInfo';
      }
    },

    matchSelectedPackage(response) {
      if (response.course.packages.length === 0) {
        return;
      }
      const selectedPackage = response.course.packages.find(
        (coursePackage) => coursePackage.title === packageType
      );
      if (selectedPackage) {
        return selectedPackage.id;
      }
      return response.course.packages.find(
        (coursePackage) => coursePackage.price === 0
      ).id;
    },

    async toCheckout() {
      if (this.$refs['billing-info'].reportValidity()) {
        await this.getXsfrToken();

        const response = await fetch(`${BASE_URL_ORDER}create`, {
          body: JSON.stringify(this.order),
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'X-XSRF-TOKEN': docCookies.getItem('XSRF-TOKEN'),
          },
          method: 'POST',
        });

        const data = await response.json();
        this.order.hash = data.hash;
        this.step = 'checkout';
      }
    },

    async submit() {
      this.step = 'submit';

      await this.getXsfrToken();

      const response = await fetch(`${BASE_URL_ORDER}submit`, {
        body: JSON.stringify({ hash: this.order.hash }),
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-XSRF-TOKEN': docCookies.getItem('XSRF-TOKEN'),
        },
        method: 'POST',
      });

      this.submitInProgress = false;

      if (!response.ok) {
        throw new Error(`Error! status: ${response.status}`);
      } else {
        this.sumbittedSuccessfully = true;

        // Zavolání funkce trackPurchase po úspěšném odeslání objednávky
        console.log(this.order.products);
        trackPurchase({
          transaction_id: this.order.hash,
          total: parseInt(this.totalPrice.noDiscount),
          tax: 0, // Příklad, upravte dle potřeby
          shipping: 0, // Příklad, upravte dle potřeby
          currency: 'CZK', // Změňte podle potřeby
          items: this.order.products.map((item) => {
            return {
              item_id: item.crm_id,
              item_name: item.course.name,
              quantity: item.attendees.length,
              price: parseInt(item.price_with_certification),
              currency: 'CZK',
              item_category: item.category,
              item_brand: item.lecturer,
            };
          }),
        });

        this.order = {
          products: [],
          contact: {
            name: '',
            email: '',
            same_delivery_details: true,
          },
          discount: {
            discount: 0,
            absoluteDiscount: false,
            promo_code: '',
          },
          hash: null,
        };
        this.$dispatch('cart:updated', 0);
      }
    },
  };
}
